import { Component, Vue } from 'vue-property-decorator'
import * as echarts from 'echarts';
import { getCustomerConversionStatisticalData } from '@/api/customer'
import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";

@Component({})
export default class ConversionTransfromStatisticsData extends Vue {
    dataFilter = 0
    customerConversionBackCount = 0 // 退回线索数量
    customerConversionCount = 0 // 接受客户数量
    marketClueIsSignCount = 0 // 签约数量总计
    marketClueIsSignRate = '0%' // 签约转化率
    marketClueIsSignPriceSum = 0 // 签约订单金额总计
    isSignPriceRankList: { userRealName: string; isSignPriceSum: number }[] = [] // 排行榜
    isShow = true //只有部门权限才展示
    dialogVisible = false
    employeeDetailsName = ''
    customerConversionFollowData = {}
    EduTemandData = []
    GradeData = []
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    timeType = '1'
    timeStr = ''

    created() {
        this.getDateInterval()
    }

    // methods
    async getData() {
        // 2022-7-25 加loading
        const loading = this.$loading({
            lock: true,
            text: '数据正在加载中……',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        const obj = {
            timeStr: this.timeStr
        }
        const data: any = await getCustomerConversionStatisticalData(obj)
        loading.close();
        const { customerConversionFollow, customerConversionBackCount, customerConversionCount, marketClueIsSignCount, marketClueIsSignRate, customerConversionGroupByUserIdObj, customerConversionLevelCount, marketClueSourceTypeCount, marketClueSourceTypeIsSignCount, customerConversionGroupByUser, isShow, marketClueIsSignPriceSum, customerConversionIsSignGroupByUser, isSignPriceRankList } = data
        this.customerConversionBackCount = customerConversionBackCount
        this.customerConversionCount = customerConversionCount
        this.marketClueIsSignCount = marketClueIsSignCount
        this.marketClueIsSignRate = marketClueIsSignRate
        this.marketClueIsSignPriceSum = marketClueIsSignPriceSum
        this.isSignPriceRankList = isSignPriceRankList
        // this.isShow = isShow
        // if (isShow) {} // 2022-8-4 暂时不用
        this.initSignContractNum(customerConversionGroupByUserIdObj)
        this.initCustomerLevelAndOvertime(customerConversionLevelCount)
        this.initCustomerFollowAverage(customerConversionFollow.customerConversionFollowList)  //客户跟进数平均值
        this.initResourceSources(marketClueSourceTypeCount)
        this.initSignContactSources(marketClueSourceTypeIsSignCount)


        this.initBubbleChart('chart-bubble1', customerConversionGroupByUser.customerConversionGroupBySpecialized)
        this.initBar('bar1', customerConversionGroupByUser.customerConversionGroupByAttendSchool)
        this.initSex('sex-ratio1', customerConversionGroupByUser.customerConversionGroupByGender)
        this.initPieGrade('pie-grade1', customerConversionGroupByUser.customerConversionGroupByGrade)
        this.initBubbleChart('chart-bubble2', customerConversionIsSignGroupByUser.customerConversionIsSignGroupBySpecialized)
        this.initBar('bar2', customerConversionIsSignGroupByUser.customerConversionIsSignGroupByAttendSchool)
        this.initSex('sex-ratio2', customerConversionIsSignGroupByUser.customerConversionIsSignGroupByGender)
        this.initPieGrade('pie-grade2', customerConversionIsSignGroupByUser.customerConversionIsSignGroupByGrade)
        // 转化客户升学需求
        this.initPieEduTemand('pie-highGrade', customerConversionGroupByUser.customerConversionGroupByEduTemand)
        // 签单升学需求
        this.initPieEduTemand('pie-highGrade2', customerConversionGroupByUser.customerConversionGroupByEduTemand)


        this.customerConversionFollowData = customerConversionFollow.customerConversionFollowList
    }

    changeRadio(val: number) {
        this.dataFilter = val
        this.getData()
    }
    // 资源签约量图表
    initSignContractNum(array) {
        let data = []
        let arr = array.customerConversionGroupByUserIdList
        if (arr.length > 0) {
            data = arr.map(item => ({
                'product': item.userRealName,
                '客户数': item.customerConversionCount,
                '签约数': item.marketClueIsSignCount,
                '签约率': parseFloat(item.marketClueIsSignRate)
            }))
            // data = array.map(item => ({ 'product': item.userRealName, '客户数': item.customerConversionCount, '签约数': item.marketClueIsSignCount, '签约率': item.marketClueIsSignCount }))
            // dataPercentage = array.map(item => ({ '签约率': item.marketClueIsSignCount }))
        } else {
            data = [{'product': '某某员工', '客户数': 0, '签约数': 0, '签约率': 0}]
        }
        const chartDom = document.getElementById('sign-contract-num');
        const myChart = echarts.init(chartDom as HTMLElement);
        myChart.on('legendselectchanged', (obj: any) => {
            if (obj.selected.签约数 && !obj.selected.客户数 && !obj.selected.签约率) {
                var op = myChart.getOption();
                op.series[1].markLine.data[0].lineStyle.opacity = 1
                myChart.setOption(op, true);
            } else if (!obj.selected.签约数 && obj.selected.客户数 && !obj.selected.签约率) {
                var op = myChart.getOption();
                op.series[0].markLine.data[0].lineStyle.opacity = 1
                myChart.setOption(op, true);
            } else {
                var op = myChart.getOption();
                op.series[0].markLine.data[0].lineStyle.opacity = 0
                op.series[1].markLine.data[0].lineStyle.opacity = 0
                myChart.setOption(op, true);
            }
        })

        let Xindex = ""
        const option = {
            title: {
                subtext: '资源签约量'
            },
            legend: {
                right: 10,
                selected: {
                    '客户数': true,
                    '签约数': true,
                    '签约率': true,
                },
                data: ['客户数', '签约数', '签约率']
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '客户数', '签约数', '签约率'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0, 0, 0, 20]
                },
                triggerEvent: true,
                axisLabel: {
                    show: true,
                    // color: function (value, index) {
                    //     return value == Xindex ? '#1eb4ff' : '#666';
                    // },
                    // textStyle: {
                    //     fontSize: function (value) {
                    //         return value == Xindex ? 18 : 12;
                    //     },
                    // },
                    interval: 0,
                    clickable: true,
                    formatter: function (value,index) {
                        let ret = "";//拼接加\n返回的类目项
                        const maxLength = 1;//每项显示文字个数
                        const valLength = value.length;//X轴类目项的文字个数
                        const rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                        if (rowN > 1)//如果类目项的文字大于3,
                        {
                            for (let i = 0; i < rowN; i++) {
                                let temp = "";//每次截取的字符串
                                const start = i * maxLength;//开始截取的位置
                                const end = start + maxLength;//结束截取的位置
                                //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                temp = value.substring(start, end) + "\n";
                                ret += temp; //凭借最终的字符串
                            }
                            return ret;
                        }
                        else {
                            return value;
                        }
                    }
                }
            },
            yAxis: [
                {type: 'value',minInterval: 10,splitNumber: 10},
                {type: 'value',axisLabel: {show: true,interval: 'auto',formatter: '{value} %'},}
                ],
            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: {color: '#E16A6A', opacity: 0.7},
                    label: {show: true, position: 'top'},
                    markLine: {data: [{type: 'average', name: 'Avg', lineStyle: {normal: {opacity: 0}}}]}
                },
                {
                    name: '签约数',
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: {color: '#F7E375', opacity: 0.7},
                    label: {show: true, position: 'top'},
                    // data: [{  name:'签约数', yAxis: array.marketClueIsSignAvg, lineStyle:{ normal:{ opacity: 0 }} }]
                    markLine: {data: [{type: 'average', name: 'Avg', lineStyle: {normal: {opacity: 0}}}]}
                },
                {
                    type: 'bar', yAxisIndex: 1, barMinHeight: 3, itemStyle: {color: '#7AFF8F', opacity: 0.7,}, label: {
                        show: true, position: 'top', formatter: function (val) {
                            return val.data.签约率 + '%'
                        }
                    }
                },
            ]
        }

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })

        option && myChart.setOption(option);

        myChart.on('click', (params) => {
            if (params.componentType == "xAxis") {
                (this.customerConversionFollowData as any).forEach((item: any) => {
                    if (item.userRealName == params.value) {
                        this.EduTemandData =  item.customerConversionGroupByEduTemand
                        this.GradeData =  item.customerConversionGroupByGrade
                        this.openEmployeeDetails(params.value, item.customerConversionGroupByEduTemand, item.customerConversionGroupByGrade);

                    }
                })
            }
        })


    }

    openEmployeeDetails(val, EduTemandList, gradeList) {
        this.dialogVisible = true
        this.employeeDetailsName = val


        let sum1 = 0
        let sum2 = 0


        EduTemandList.forEach((item, index) => {
            sum1 += Number(item.count)
            item.value = item.count
            item.name = item.eduTemand
        })

        gradeList.forEach((item, index) => {
            sum2 += Number(item.count)
            item.value = item.count
            item.name = item.grade
        })


        this.$nextTick(() => {
            const myChart1 = echarts.init(this.$refs.pieEmployeeGrade as HTMLElement);
            const option1 = {
                title: {
                    text: '所在年级占比',
                    // subtext: 'Fake Data',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    // formatter: '{c}%',
                },
                series: [
                    {
                        // name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: gradeList,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + Math.floor(params.data.value / sum2 *100) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]

            };
            option1 && myChart1.setOption(option1);

            const myChart2 = echarts.init(this.$refs.pieEmployeeEduTemand as HTMLElement);
            const option2 = {
                title: {
                    text: '升学需求占比',
                    // subtext: 'Fake Data',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    // formatter: '{c}%',
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        data: EduTemandList,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + Math.floor(params.data.value / sum1*100 ) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
            option2 && myChart2.setOption(option2);
        })
    }
    // 客户等级以及跟进超时情况图表
    initCustomerLevelAndOvertime(array) {
        let userList = []
        let userList2 = []
        let customerConversionOvertimeCount = []
        let customerConversionLevel3Count = []
        let customerConversionLevel2Count = []
        let customerConversionLevel1Count = []
        if (array.length > 0) {
            userList = array.map(item => item.userRealName)
            array.forEach(item => {
                userList2.push(item.userRealName)
                userList2.push(item.userRealName)
                userList2.push(item.userRealName)
            })
            customerConversionLevel3Count = array.map(item => item.customerConversionLevel3Count)
            customerConversionLevel2Count = array.map(item => item.customerConversionLevel2Count)
            customerConversionLevel1Count = array.map(item => item.customerConversionLevel1Count)
            array.forEach(item => {
                customerConversionOvertimeCount.push(item.customerConversionOvertimeLevel3Count)
                customerConversionOvertimeCount.push(item.customerConversionOvertimeLevel2Count)
                customerConversionOvertimeCount.push(item.customerConversionOvertimeLevel1Count)
            })
        } else {
            userList = ['某某员工']
            userList2 = ['某某员工', '某某员工', '某某员工']
            customerConversionLevel3Count = [0]
            customerConversionLevel2Count = [0]
            customerConversionLevel1Count = [0]
            customerConversionOvertimeCount = [0, 0, 0]
        }


        const chartDom = document.getElementById('customer-level-and-overtime');
        const myChart = echarts.init(chartDom as HTMLElement);
        const option = {
            title: {
                subtext: '客户等级数量以及跟进超时情况'
            },
            tooltip: {
                trigger: 'item',
            },
            legend: {
                data: ['3级客户', '2级客户', '1级客户', '超时数量'],
                right: 10
            },
            xAxis: [
                {
                    type: 'category',
                    data: userList,
                    position: 'bottom',
                    axisPointer: {
                        type: 'shadow'
                    },
                    triggerEvent: true,
                    axisLabel: {
                        // color: function (value, index) {
                        //     return value == Xindex ? '#1eb4ff' : '#666';
                        // },
                        // fontSize: function (value, index) {
                        //     return value == Xindex ? 20 : 12
                        // },
                        clickable: true,
                        interval: 0,
                        formatter: function (value) {
                            let ret = "";//拼接加\n返回的类目项
                            const maxLength = 1;//每项显示文字个数
                            const valLength = value.length;//X轴类目项的文字个数
                            const rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                            if (rowN > 1)//如果类目项的文字大于3,
                            {
                                for (let i = 0; i < rowN; i++) {
                                    let temp = "";//每次截取的字符串
                                    const start = i * maxLength;//开始截取的位置
                                    const end = start + maxLength;//结束截取的位置
                                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp; //凭借最终的字符串
                                }
                                return ret;
                            }
                            else {
                                return value;
                            }
                        }

                    }
                },
                {
                    type: 'category',
                    data: userList2,
                    position: 'top',
                    show: false,
                    axisPointer: {
                        type: 'shadow'
                    },
                    max: 'dataMax',
                    min: 0,
                    splitNumber: 5,
                    nameTextStyle: {
                        backgroundColor: 'rgba(0,0,0,0)'
                    }
                },

            ],
            yAxis: [
                {
                    type: 'value',
                    name: '',
                    axisLabel: {
                        formatter: '{value}'
                    },
                    minInterval: 10,
                    splitNumber: 10
                },
            ],
            color: ['#E16A6A', '#F7E375', '#7AFF8F', '#666666'],
            series: [
                {
                    name: '3级客户',
                    type: 'bar',
                    barWidth: '28%',
                    data: customerConversionLevel3Count,
                    barMinHeight: 3,
                    itemStyle: {
                        opacity: 0.7
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                },
                {
                    name: '2级客户',
                    type: 'bar',
                    barWidth: '28%',
                    data: customerConversionLevel2Count,
                    barMinHeight: 3,
                    itemStyle: {
                        opacity: 0.7
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                },
                {
                    name: '1级客户',
                    type: 'bar',
                    barWidth: '28%',
                    data: customerConversionLevel1Count,
                    barMinHeight: 3,
                    itemStyle: {
                        opacity: 0.7
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                },
                {
                    name: '超时数量',
                    type: 'line',
                    xAxisIndex: 1,
                    data: customerConversionOvertimeCount,
                    label: {
                        show: true,
                        position: 'bottom',
                        formatter: (params) => {
                            return params.value === 0 ? '' : params.value
                        }
                    }
                },
            ]
        };

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })
        option && myChart.setOption(option);

        myChart.on('click', (params) => {
            if (params.componentType == "xAxis") {
                (this.customerConversionFollowData as any).forEach((item: any) => {
                    if (item.userRealName == params.value) {
                        this.EduTemandData =  item.customerConversionGroupByEduTemand
                        this.GradeData =  item.customerConversionGroupByGrade

                        this.openEmployeeDetails(params.value, item.customerConversionGroupByEduTemand, item.customerConversionGroupByGrade);
                    }
                })
            }
        })
    }

    // 客户跟进数平均值
    initCustomerFollowAverage(array) {
        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ 'product': item.userRealName, '客户跟进数': item.customerConversionFollowCount, }))
        } else {
            data = [{ 'product': '某某客户', '客户跟进数': 0 }]
        }
        const chartDom = document.getElementById('customer-follow-average');
        const myChart = echarts.init(chartDom as HTMLElement);


        const option = {
            title: {
                subtext: '客户跟进数'
            },
            legend: {
                right: 10
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '客户跟进数'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0,0,0,20]
                },
                triggerEvent: true,
                axisLabel: {
                    // color: function (value, index) {
                    //     return value == Xindex ? '#1eb4ff' : '#666';
                    // },
                    // fontSize: (value) => value == Xindex ? 20 : 12,
                    clickable: true,
                    interval: 0,
                    formatter: function (value) {
                        //x轴的文字改为竖版显示
                        var str = value.split("");
                        return str.join("\n");
                    }
                    // formatter: function (value) {
                    //     let ret = "";//拼接加\n返回的类目项
                    //     const maxLength = 1;//每项显示文字个数
                    //     const valLength = value.length;//X轴类目项的文字个数
                    //     const rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                    //     if (rowN > 1)//如果类目项的文字大于3,
                    //     {
                    //         for (let i = 0; i < rowN; i++) {
                    //             let temp = "";//每次截取的字符串
                    //             const start = i * maxLength;//开始截取的位置
                    //             const end = start + maxLength;//结束截取的位置
                    //             //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                    //             temp = value.substring(start, end) + "\n";
                    //             ret += temp; //凭借最终的字符串
                    //         }
                    //         return ret;
                    //     }
                    //     else {
                    //         return value;
                    //     }
                    // }
                }
            },
            yAxis: [
                { type: 'value' }
                // {type: 'value',minInterval: 10,splitNumber: 10},
                // {type: 'value',axisLabel: {show: true,interval: 'auto',formatter: '{value} %'},}
                ],
            // yAxis: {
            //     minInterval: 10,
            //     splitNumber: 10
            // },
            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: { color: '#6583F9', opacity: 0.7 },
                    label: { show: true, position: 'top' },
                    // markPoint: {
                    //     data: [
                    //         { name: 'Max', value: 182.2, xAxis: 7, yAxis: 183 },
                    //         { name: 'Min', value: 2.3, xAxis: 11, yAxis: 3 }
                    //     ]
                    // },
                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                },
                // { type: 'bar', yAxisIndex: 0,barMinHeight: 3, itemStyle: { color: '#F7E375', opacity: 0.7 }, label: { show: true, position: 'top' } },
                // { type: 'bar', yAxisIndex: 1,barMinHeight: 3, itemStyle: { color: '#7AFF8F', opacity: 0.7, }, label: { show: true, position: 'top',formatter: function(val){
                //     return val.data.签约率 + '%'
                // } }},
            ]
        }

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })

        option && myChart.setOption(option);

        myChart.on('click', (params) => {
            if (params.componentType == "xAxis") {
                (this.customerConversionFollowData as any).forEach((item: any) => {
                    if (item.userRealName == params.value) {
                        this.EduTemandData =  item.customerConversionGroupByEduTemand
                        this.GradeData =  item.customerConversionGroupByGrade
                        this.openEmployeeDetails(params.value, item.customerConversionGroupByEduTemand, item.customerConversionGroupByGrade);
                    }
                })
            }
        })
    }



    // 资源来源比
    initResourceSources(array) {
        const data = array.map(item => ({ name: item.sourceTypeName, value: item.marketClueCount }))
        let total = 0
        array.forEach(item => {
            total += item.marketClueCount
        })
        const chartDom = document.getElementById('pie-resources');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: total,
                left: 'center',
                padding: [160, 0, 0, 0],
                textStyle: {
                    fontSize: 30
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: ''
            },
            color: ['#EF7878', '#FF49C1', '#FFEE28', '#28E4DC', '#C64DCB'],
            legend: {
                top: '5%',
                left: 'center',
                show: false,
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['40%', '60%'],
                    avoidLabelOverlap: false,
                    label: {
                        formatter: (params) => {
                            let str = params.data.name + ': '
                            if (params.data.value > 0) {
                                str += params.data.value + '个' + '\n' + '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    },
                    data: data
                }
            ]
        };

        option && myChart.setOption(option);


    }
    // 初始化签约来源比
    initSignContactSources(array) {
        const data = array.map(item => ({ name: item.sourceTypeName, value: item.marketClueCount }))
        let total = 0
        array.forEach(item => {
            total += item.marketClueCount
        })
        const chartDom = document.getElementById('pie-sign-contract');
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: total,
                left: 'center',
                padding: [160, 0, 0, 0],
                textStyle: {
                    fontSize: 30
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: ''
            },
            color: ['#EF7878', '#FF49C1', '#FFEE28', '#28E4DC', '#C64DCB'],
            legend: {
                top: '5%',
                left: 'center',
                show: false,
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['40%', '60%'],
                    avoidLabelOverlap: false,
                    label: {
                        formatter: (params) => {
                            let str = params.data.name + ': '
                            if (params.data.value > 0) {
                                str += params.data.value + '个' + '\n' + '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    },
                    data: data
                }
            ]
        };

        option && myChart.setOption(option);

    }

    // 初始化气泡图----专业
    initBubbleChart(id: string, array) {
        const chartDom = document.getElementById(id);
        const myChart = echarts.init(chartDom as HTMLElement);
        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ name: item.specialized, value: item.count }))
        } else {
            data.push({ name: '某某专业', value: 100 })
        }
        let total = 0
        data.forEach((item: { value: number; name: string }) => {
            total += Number(item.value)
        })
        // const option = {
        //     tooltip: {},
        //     legend: [{
        //         show: false
        //     }],
        //     width: '100%',
        //     color: ['#97AEFF', '#97D2FF', '#F9B2B2', '#CD97FF', '#FB97FF', '#CCFF97', '#97FFDB', '#FEDFDF'],
        //     series: [
        //         {
        //             name: '',
        //             type: 'graph',
        //             layout: 'force',
        //             data: data,
        //             roam: true,
        //             draggable: true,
        //             zoom: 1,
        //             label: {
        //                 show: true,
        //                 position: 'inside',
        //                 formatter: (params) => {
        //                     let str = params.data.name
        //                     if (params.data.value > 0) {
        //                         str += '\n' + Math.floor(params.data.value / total * 100) + '%'
        //                     } else {
        //                         str += '\n' + '0%'
        //                     }
        //                     return str
        //                 }
        //             },
        //             force: {
        //                 repulsion: 100,
        //                 initLayout: 'circular',
        //                 gravity: 0.05
        //             },
        //             // labelLayout: {
        //             //     hideOverlap: true
        //             // },
        //             scaleLimit: {
        //                 min: 1,
        //                 max: 5
        //             },
        //             symbolSize: (value) => {
        //                 let val = value
        //                 if (val < 20) val = 20
        //                 if (val > 80) val = 80
        //                 return val
        //             },
        //             lineStyle: {
        //                 color: 'rgba(0,0,0,0)',
        //             }
        //         }
        //     ]
        // }

        const option = {
            grid: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                containLabel: true
            },
            color: ['#97AEFF', '#97D2FF', '#F9B2B2', '#CD97FF', '#FB97FF', '#CCFF97', '#97FFDB', '#FEDFDF'],
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: false
            },
            yAxis: {
                type: 'category',
                // data: yAxisData,
                axisLabel: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true
                }
            },
            dataset: {
                dimensions: ['name', 'value'],
                source: data
            },
            series: [
                {
                    name: '2011年',
                    type: 'bar',
                    barWidth: 20,
                    barMinHeight: 3,
                    // data: data,
                    label: {
                        show: true,
                        formatter: (params) => {
                            return params.data.name + (params.data.value === 0 ? '' : ': ' + params.data.value)
                        },
                        // position: 'insideLeft',
                        position: ['0%', '0%'],
                        // position: ['50%', '20%']
                    },
                    itemStyle: {
                        barBorderRadius: [0, 10, 10, 0]
                    }
                },
            ]
        };
        myChart.setOption(option);
    }
    // 初始化条形图----学校
    initBar(id: string, array) {
        let data = []
        let yAxisData = []
        if (array.length > 0) {
            data = array.map(item => ({ name: item.attendSchool, value: item.count }))
            yAxisData = array.map(item => item.attendSchool)
        } else {
            data.push({ name: '暂无数据', value: 0 })
            yAxisData.push('暂无数据')
        }
        const chartDom = document.getElementById(id);
        const myChart = echarts.init(chartDom);
        const option = {
            grid: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                containLabel: true
            },
            color: ['#97AEFF', '#97D2FF', '#F9B2B2', '#CD97FF', '#FB97FF', '#CCFF97', '#97FFDB', '#FEDFDF'],
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                show: false
            },
            yAxis: {
                type: 'category',
                // data: yAxisData,
                axisLabel: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true
                }
            },
            dataset: {
                dimensions: ['name', 'value'],
                source: data
            },
            series: [
                {
                    name: '2011年',
                    type: 'bar',
                    barWidth: 20,
                    barMinHeight: 3,
                    // data: data,
                    label: {
                        show: true,
                        formatter: (params) => {
                            return params.data.name + (params.data.value === 0 ? '' : ': ' + params.data.value)
                        },
                        // position: 'insideLeft',
                        position: ['0%', '0%'],
                        // position: ['50%', '20%']
                    },
                    itemStyle: {
                        barBorderRadius: [0, 10, 10, 0]
                    }
                },
            ]

        };

        option && myChart.setOption(option);
    }
    // 初始化性别占比
    initSex(id: string, array) {
        const chartDom = document.getElementById(id);
        const myChart = echarts.init(chartDom);
        const data = [
            {
                name: '女',
                type: 'bar',
                stack: 'Ad',
                emphasis: {
                    focus: 'series'
                },
                data: [0]
            },
            {
                name: '未知',
                type: 'bar',
                stack: 'Ad',
                emphasis: {
                    focus: 'series'
                },
                data: [0]
            },
            {
                name: '男',
                type: 'bar',
                stack: 'Ad',
                emphasis: {
                    focus: 'series'
                },
                data: [0]
            },

        ]
        if (array.length > 0) {
            array.forEach(item => {
                switch (item.gender) {
                    case '男':
                        data[2].data = [Number(item.count)]
                        break;
                    case '女':
                        data[0].data = [Number(item.count)]
                        break;
                    case '未知':
                        data[1].data = [Number(item.count)]
                        break;
                }
            })
        }
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'none',
                },
                formatter: function (params) {//提示内容
                    let relVal = "性别";
                    params.forEach((item)=>{
                        relVal +=
                            "<br/>" +
                            item.seriesName +
                            " : " +
                            item.value.toLocaleString();
                    })
                    return relVal;
                },
                textStyle: {
                    // align: 'right',
                    fontSize: '12',
                    color: '#666'
                },
            },
            color: ['#FEDFDF', '#9EFFF9', '#83BAF3'],
            legend: {
                show: false,
            },
            grid: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: ['性别'],
                    show: false,
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    show: false,
                }
            ],
            series: data
        };

        option && myChart.setOption(option);
    }
    // 初始化年级占比
    initPieGrade(id: string, array) {
        let data = []
        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({ name: item.grade, value: item.count }))
            array.forEach(item => { total += Number(item.count) })
        } else {
            data.push({ name: '某某年级', value: 0 })
        }
        const chartDom = document.getElementById(id);
        const myChart = echarts.init(chartDom as HTMLElement);
        const option = {

            tooltip: {
                trigger: 'item',
                renderMode: 'richText'
            },
            roam: false,
            nodeClick: false,
            color: ['#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F', '#6583F9'],
            series: [
                {
                    name: '学生年级',
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 1,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    },
                }
            ]
        };
        option && myChart.setOption(option);
    }

    // 初始化升学需求占比
    initPieEduTemand(id: string, array) {
        let data = []
        let total = 0
        if (array.length > 0) {
            data = array.map(item => ({ name: item.eduTemand, value: item.count }))
            array.forEach(item => { total += Number(item.count) })
        } else {
            data.push({ name: '某某年级', value: 0 })
        }
        const chartDom = document.getElementById(id);
        const myChart = echarts.init(chartDom as HTMLElement);
        const option = {

            tooltip: {
                trigger: 'item',
                renderMode: 'richText'
            },
            roam: false,
            nodeClick: false,
            color: ['#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F', '#6583F9'],
            series: [
                {
                    name: '学生年级',
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 1,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        align: 'center',
                        fontSize: 10,
                        formatter: (params) => {
                            let str = params.data.name + '\n'
                            if (params.data.value > 0) {
                                str += '占比' + Math.floor(params.data.value / total * 100) + '%'
                            } else {
                                str += '0%'
                            }
                            return str
                        }
                    },
                }
            ]
        };
        option && myChart.setOption(option);
    }

    handleClose(done) {
        // this.$confirm('确认关闭？')
        //     .then(_ => {
        //         done();
        //     })
        //     .catch(_ => {});
        this.dialogVisible = false
    }



    //    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        }

    }
    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek,this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth,this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter,this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear,this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek,this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth,this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter,this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart,this.yesteryearEnd]
        }else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday,this.yesterday]
        }else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today,this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }


        if (this.timeStr) {
            this.getData()
        }

    }

    handleChangeData(val) {
        const  week = [this.startWeek,this.endWeek]
        const  month = [this.startMonth,this.endMonth]
        const  year = [this.startYear,this.endYear]
        const  quarter = [this.startQuarter,this.endQuarter]
        const  lastWeek = [this.startLastWeek,this.endLastWeek]
        const  lastMonth = [this.startLastMonth,this.endLastMonth]
        const  lastQuarter = [this.startLastQuarter,this.endLastQuarter]
        const  lastyear = [this.yesteryearStart,this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        }  else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        }else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getData()
    }
}
